module.exports = __webpack_public_path__ + "static/img/shi.7871d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shi.jpg
// module id = JVZL
// module chunks = 1